export enum F11EstadoCreacionEnum {
  EN_PROCESO = "En Proceso",
  CREADO = "Creado",
}
